import { createApp } from 'vue'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import { useGetUserMarketAndRole } from '@/utils/helperFunctions'
import appConfig from '@/config'
import router from '@/router'
import App from '@/App.vue'
import VueGtag from 'vue-gtag'
import store from '@/store'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/base.css'
import 'bootstrap'
import '@/styles/app.css'
import tooltip from './directives/tooltip'

const oktaAuth = new OktaAuth(appConfig.oidc)

const app = createApp(App)

app
  .use(router)
  .use(store)
  .directive('tooltip', tooltip)
  .use(OktaVue, {
    oktaAuth,
    onAuthRequired: () => {
      router.push('/login')
    },
    onAuthResume: () => {
      router.push('/login')
    },
  })

if (appConfig.googleAnalyticsMeasurementId) {
  app.use(
    VueGtag,
    {
      pageTrackerTemplate(to) {
        let userOktaToken = oktaAuth.tokenManager.storage.storageProvider.getItem('okta-token-storage')
        userOktaToken = JSON.parse(userOktaToken)
        const groups = useGetUserMarketAndRole(userOktaToken.accessToken.claims.socialkit_groups)
        return {
          page_title: to.name,
          page_path: to.path,
          user_role: groups.role.toLowerCase() === 'sa' ? 'Super Admin' : groups.role,
          user_id: userOktaToken.idToken.claims.sub,
        }
      },
      config: {
        id: appConfig.googleAnalyticsMeasurementId,
      },
    },
    router,
  )
}

app.mount('#app')
